import React from "react";
import { Ruler, HardHat, Users, PenTool, ShieldCheck, ClipboardCheck } from "lucide-react";
import SEO from "@/components/SEO";

const HERO =
  "https://images.unsplash.com/photo-1764737740462-2a310c7b2c39?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxhcmNoaXRlY3RzJTIwYXQlMjB3b3JrJTIwYmx1ZXByaW50JTIwb2ZmaWNlfGVufDB8fHx8MTc4MzQyOTQwNHww&ixlib=rb-4.1.0&q=85";

const roles = [
  { icon: PenTool, title: "Architetti", desc: "Progettazione interni ed edifici, render 3D, moodboard materiali, direzione artistica. Il progetto nasce con te, non a valle." },
  { icon: Ruler, title: "Geometri", desc: "Rilievi, pratiche catastali, SCIA/CILA, coordinamento con enti locali." },
  { icon: HardHat, title: "Ingegneri strutturisti", desc: "Calcoli statici, verifiche sismiche, miglioramento strutturale, certificazioni." },
  { icon: ClipboardCheck, title: "Ufficio tecnico interno", desc: "Direzione lavori, pratiche edilizie, coordinamento con enti, gestione varianti." },
  { icon: Users, title: "Capicantiere & maestranze", desc: "Squadre interne specializzate: muratori, elettricisti, idraulici, marmisti, serramentisti." },
  { icon: ShieldCheck, title: "Ufficio sicurezza", desc: "Coordinatore per la sicurezza in fase di progettazione ed esecuzione (CSP/CSE), DVR, POS." },
];

export default function Team() {
  return (
    <div>
      <SEO
        title="Il Team — Architetti, ingegneri e legali interni | Ri.Sco. Napoli"
        description="Il team Ri.Sco. a Napoli: architetti, geometri, ingegneri strutturisti, consulenti legali, capicantiere e maestranze. Filiera completa interna per Napoli e provincia."
        path="/team"
      />
      <section className="relative min-h-[80vh] flex items-end overflow-hidden -mt-20 pt-20" data-testid="team-hero">
        <div className="absolute inset-0">
          <img src={HERO} alt="Team Ri.Sco. al lavoro" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-risco-ink/95 via-risco-ink/60 to-risco-ink/30" />
        </div>
        <div className="relative container-x py-20 md:py-28 w-full">
          <div className="grid lg:grid-cols-12 gap-8 items-end">
            <div className="lg:col-span-8">
              <div className="rule-tag text-stone-300 text-xs uppercase tracking-[0.28em] mb-8">Il Team</div>
              <h1 className="text-risco-bg leading-[0.95]">
                <span className="font-heading font-medium text-4xl sm:text-5xl md:text-6xl lg:text-8xl block tracking-tighter">Filiera completa</span>
                <span className="font-display italic text-4xl sm:text-5xl md:text-6xl lg:text-8xl block">un solo referente.</span>
              </h1>
            </div>
            <div className="lg:col-span-4 lg:pl-8">
              <p className="text-stone-200 text-base leading-relaxed max-w-md">
                Ogni ruolo tecnico è interno all'azienda: parli con noi, decidi con noi, controlli con noi.
                Nessuna filiera di appalti che si scaricano le responsabilità.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 md:py-24" data-testid="team-roles">
        <div className="container-x">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {roles.map((r) => (
              <div key={r.title} className="risco-card p-8" data-testid={`team-role-${r.title.toLowerCase().replace(/ /g, "-").replace(/&/g, "e")}`}>
                <div className="w-12 h-12 rounded-md bg-risco-accent-soft border border-risco-accent/50 flex items-center justify-center mb-5">
                  <r.icon className="w-6 h-6 text-risco-accent" />
                </div>
                <div className="font-heading text-xl text-risco-ink">{r.title}</div>
                <div className="text-sm text-risco-muted mt-3 leading-relaxed">{r.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 md:py-24 border-t border-risco-border bg-risco-alt" data-testid="team-benefit">
        <div className="container-x grid md:grid-cols-3 gap-6 text-center">
          {[
            { k: "Tempi certi", d: "Cronoprogramma dettagliato, aggiornato ogni settimana." },
            { k: "Costi controllati", d: "Preventivo voce per voce, contratto chiaro, varianti autorizzate." },
            { k: "Un solo referente", d: "Non coordini più professionisti diversi: parli con noi." },
          ].map((x) => (
            <div key={x.k} className="risco-card p-8" data-testid={`team-benefit-${x.k.toLowerCase().replace(/ /g, "-")}`}>
              <div className="font-heading text-2xl text-risco-accent">{x.k}</div>
              <div className="text-stone-700 mt-3">{x.d}</div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
